import { make } from 'vuex-pathify';
import { filter, keys, keyBy, map, reduce, sortBy, uniq, values } from 'lodash';

const game = keyBy(
    [
        {
            id: 1,
            category: 'Hormones',
            question: 'True or false: Sharing hormone needles with your friend is okay, as long as you know them well.',
            blurb:
                'Sharing needles with anyone at any time is a big HIV risk. You can get needles from your doctor or from a needle exchange/syringe service (here’s one option: <a href="https://www.nasen.org/map/" target="_blank">www.nasen.org/map</a>). If you have NO way of getting a clean needle, clean the used needle before injecting it into your own skin by flushing the entire thing out with bleach 3 times, followed by clean water 3 times.',
            correctAnswer: 'false',
            points: 100,
            answer: ''
        },
        {
            id: 2,
            category: 'Hormones',
            question: 'True or False: If you wanna change your body faster, just take more hormones.',
            blurb:
                'Body changes take some time and taking more hormones will NOT make your body change faster!  In fact, it can be damaging to your body and health by overloading your liver, kidneys, and heart.  That’s why doctors take blood tests before prescribing you hormones and even after you have been on them for a while — to check what your body can handle.  It’s personal to each person’s body. MORE (as in more hormones) does not always mean MORE as in more body changes. It may just mean MORE as in more side effects or health problems.',
            correctAnswer: 'false',
            points: 200,
            answer: ''
        },
        {
            id: 3,
            category: 'Hormones',
            question: 'True or False: While taking estrogen, smoking may increase your risk for blood clots, heart attack, and stroke.',
            blurb:
                'Blood clots (clogs in your blood vessels) are relatively uncommon but one of the potentially most dangerous risk factors associated with taking estrogen, especially among smokers. You should avoid smoking if you are taking estrogen.',
            correctAnswer: 'true',
            points: 300,
            answer: ''
        },
        {
            id: 4,
            category: 'Hormones',
            question: 'True or False: After you insert the needle into your muscle, you should pull back the plunger a little bit to check for blood.',
            blurb:
                'If there is any blood, you have hit a blood vessel (vein or artery) and should take the needle out and re-inject at another location. Injecting into a blood vessel is dangerous and will lead to getting too much medication into the bloodstream.',
            correctAnswer: 'true',
            points: 400,
            answer: ''
        },
        {
            id: 5,
            category: 'Pumping',
            question:
                'True or False: Pumping is when a person gets silicone (or something they think is silicone) injected into different areas of their body to make them look curvier and/or more feminine.',
            blurb: '',
            correctAnswer: 'true',
            points: 100,
            answer: ''
        },
        {
            id: 6,
            category: 'Pumping',
            question: 'True or False: Pump Doctors are just like other doctors.',
            blurb:
                '“Pump Doctors” are not licensed physicians and they are not required or trained whatsoever to be a “pump doctor.” Medical providers have to use clean needles and the substances and medications they inject are approved and safe. Pump Doctors don’t have any of those requirements. Because of this, pumping is considered a serious health risk.',
            correctAnswer: 'false',
            points: 200,
            answer: ''
        },
        {
            id: 7,
            category: 'Pumping',
            question: 'True or False: When you get pumped, the silicone stays just in the spot where the Pump Doctor injected it.',
            blurb:
                'Since it’s not encased in anything (like a breast implant), injected silicone can move or migrate to any other spot on your body, ending up in spots you DON’T want it.  Gravity can have its way, big time. Silicone or substances injected in your face to give you cheek bones or in your breasts, butt, or hips to give you curves may just end up at your ankles – not pretty. Also… it’s a foreign substance that your body may fight against causing immune system problems.  I don’t want to scare you – but it is important for me to give you the real T. Pumping is clearly something a lot of people will decide to do but it can be very dangerous. It’s even been linked to some deaths among trans folks… so be careful.',
            correctAnswer: 'false',
            points: 300,
            answer: ''
        },
        {
            id: 8,
            category: 'Pumping',
            question:
                'True or False: When you get pumped (by someone who is not a licensed medical provider), you can’t know for sure that you’re being injected with silicone.',
            blurb:
                'Sometimes silicone is mixed with other things and there’s no way to tell what they’re injecting into you — could be low grade silicone, could not even be silicone at all — could be bathtub caulking for all you know! This can cause serious problems for your health.',
            correctAnswer: 'true',
            points: 400,
            answer: ''
        },
        {
            id: 9,
            category: 'Surgeries',
            question: 'True or False: All trans folks have surgery eventually.',
            blurb:
                'Different people have different feelings and goals for their own bodies, and not all trans people want surgeries.  Also, surgeries are expensive and not everyone who wants surgeries can afford them or has insurance that will cover them.  Although it’s becoming more available,  there’s a limited number of doctors who have experience performing bottom surgeries.  If you meet with someone who says they can do bottom surgery, ask about how much experience they have.  Do your research!',
            correctAnswer: 'false',
            points: 100,
            answer: ''
        },
        {
            id: 10,
            category: 'Surgeries',
            question: 'True or False: “Getting the surgery” means you are getting a vagina.',
            blurb:
                'When people say, “the surgery”, they usually mean you are getting bottom surgery or “a vagina.”  However, there are actually different bottom surgeries that trans women get including orchiectomy (having your testicles or balls removed), vaginoplasty (getting a vagina), and labiaplasty (creating or reshaping labia or lips around the vagina).',
            correctAnswer: 'false',
            points: 200,
            answer: ''
        },
        {
            id: 11,
            category: 'Surgeries',
            question: 'True or False: After having bottom surgery, you can’t have an orgasm.',
            blurb:
                'Everyone’s ability to have an orgasm or reach a climax is different (regardless of surgeries). The goal is for folks to be able to enjoy sex and reach climax after surgery.  Another thing to remember is that hormones can sometimes make it hard for women to have an orgasm.  You can talk about this with the doctor or nurse managing your hormones.',
            correctAnswer: 'false',
            points: 300,
            answer: ''
        },
        {
            id: 12,
            category: 'Surgeries',
            question:
                'True or False: The higher the price for vaginoplasty (removal of the male genitals to make a vagina) or getting a vagina, the better the result.',
            blurb:
                'Actually, there is a range of prices for bottom surgery, depending on which doctor you go to and where that doctor is located (like in the US, Thailand, or Brazil).  However, the price isn’t what determines how good your surgery will be.   What’s most important is to find out as much as you can about the doctor you’re thinking of going to. Ask others that have gone to them, look online for pictures, prices, and reviews.  Ask the doctor how often their patients have problems with their surgery. The price can range anywhere from a few grand to more than $20,000 (for just a vaginoplasty). It’s also a good idea to check with your health insurance provider to see if they cover vaginoplasty, or any other surgery you are considering. More and more insurance plans cover some or all of the cost of gender-affirming surgery, so it’s worth looking into!',
            correctAnswer: 'false',
            points: 400,
            answer: ''
        }
    ],
    'id'
);
const gameOrder = sortBy(keys(game), k => parseInt(k));

const state = {
    title: 'Jeopar-T',
    complete: false,
    sticker: {
        text: 'Gold medal winner',
        earned: false,
        image: require('@/assets/stickers/stickers_0013_medal.png')
    },
    bonusSticker: {
        text: 'Perfect score',
        earned: false,
        image: require('@/assets/stickers/stickers_0017_3K.png')
    },
    trophy: false,
    game,
    gameOrder
};
const getters = {
    ...make.getters(state),
    categories: state => {
        return uniq(map(values(state.game), 'category'));
    },
    allAnswered: state => {
        return 0 === filter(values(state.game), { answer: '' }).length;
    },
    score: state => {
        return reduce(
            state.game,
            (sum, item) => {
                if (item.correctAnswer === item.answer) {
                    return sum + item.points;
                }
                return sum;
            },
            0
        );
    },
    maxScore: state => {
        return reduce(
            state.game,
            (sum, item) => {
                return sum + item.points;
            },
            0
        );
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
